import { render, staticRenderFns } from "./personalMsg.vue?vue&type=template&id=1f72d872"
import script from "./personalMsg.vue?vue&type=script&lang=js"
export * from "./personalMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f72d872')) {
      api.createRecord('1f72d872', component.options)
    } else {
      api.reload('1f72d872', component.options)
    }
    module.hot.accept("./personalMsg.vue?vue&type=template&id=1f72d872", function () {
      api.rerender('1f72d872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/pages/personalMsg.vue"
export default component.exports